import React from 'react';
import NavBar from '../components/shared/Navbar';
import Title from '../components/shared/Title';
import styled from 'styled-components';
import Icon from '../components/shared/Icon';
import Text from '../components/shared/Text';
import { palette, breakpoints } from '../constants/styles';
import Footer from '../components/landing/Footer';
import { useEffect } from 'react';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;

  ${breakpoints.mobileLandscape} {
    padding: 20px 100px 80px 100px;
  }

  ${breakpoints.tabletLandscape} {
    padding: 20px 250px 80px 250px;
  }

  ${breakpoints.desktop} {
    padding: 20px 33% 80px 33%;
  }
`;

const ClingWrapper = styled.div`
  margin: 50px 0px;
`;

export default function Failure() {
  return (
    <>
      <NavBar />
      <Content>
        <ClingWrapper>
          <Icon icon="warning" color={palette.secondaryColor} size={150} />
        </ClingWrapper>
        <Title level={3}>Oops! Algo salió mal </Title>
        <Text type="body2" style={{ marginTop: '25px' }}>
          No logramos procesar tu solicitúd de plan de pensión. Favor de intentar de nuevo en otra
          pestaña / navegador.
        </Text>
        <Title level={5} align="left" style={{ alignSelf: 'flex-start', marginTop: '25px' }}>
          - Equipo Finauta
        </Title>
      </Content>
      <Footer />
    </>
  );
}
